
import React, { useState, useEffect } from 'react';
import styles from './GrowthTrackingTab.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';

import speedIcon from '../GrowthTrackingTab_bus/Params_Icon/speed.png';
import accelerationIcon from '../GrowthTrackingTab_bus/Params_Icon/acceleration pedal position.png';
import rpmIcon from '../GrowthTrackingTab_bus/Params_Icon/rpm.png';
import idlingIcon from '../GrowthTrackingTab_bus/Params_Icon/idling.png';
import coastingIcon from '../GrowthTrackingTab_bus/Params_Icon/coasting.png';
import regenerationIcon from '../GrowthTrackingTab_bus/Params_Icon/regeneration.png';
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const ParameterComparison = ({ onViewGraph, filterdata, clearFilters }) => {
  const { sendReq: fetchData } = useHttp();
  const [selectedPeriod, setSelectedPeriod] = useState('Last Month');
  const [parameterData, setParameterData] = useState([]);

  // ✅ Dynamic date range calculation
  const getDateRanges = () => {
    // const now = new Date();
    const now = new Date();
    now.setDate(now.getDate() - 1);

    // Current month
    const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    const currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    // Last month
    const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

    const format = (date) =>
      `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}`;

    return {
      lastMonthStartDate: format(lastMonthStart),
      lastMonthEndDate: format(lastMonthEnd),
      currentMonthStartDate: format(currentMonthStart),
      currentMonthEndDate: format(currentMonthEnd)
    };
  };

  const getDateRangeLabel = () => {
    const { lastMonthStartDate, lastMonthEndDate } = getDateRanges();
    if (selectedPeriod === 'Last Month') return `(${lastMonthStartDate} - ${lastMonthEndDate})`;
    if (selectedPeriod === 'Enrollment Month') return '(01 Apr \'25 - 30 Apr \'25)';
    return '';
  };

  useEffect(() => {

    const dateRanges = getDateRanges();

    const requestBody = {
      filterdata,
      ...dateRanges

    };


    fetchData(
      { url: API_URL_MAIN + 'growth_tracking/parameter_comparison', body: requestBody },
      (result) => {

        if (result && result.globalAverages) {
          const paramMap = {
            'averageOfSpeed': 'Speed',
            'Accelarator Pedal': 'Accelerator Pedal Position',
            'RPM': 'RPM',
            'Idling': 'Idling',
            'Coasting': 'Coasting',
            'Regeneration': 'Regeneration'
          };

          const flatData = Object.entries(paramMap).map(([apiKey, uiLabel]) => {
            const data = result.globalAverages[apiKey] || {};
            return {
              parameter: uiLabel,
              lastMonthAchv: (data.avgPreviousMonth ?? 0).toFixed(2),
              currentMonthAchv: (data.avgCurrentMonth ?? 0).toFixed(2)
            };
          });

          setParameterData(flatData);
        } else {
          setParameterData([]);
        }


      }
    );
  }, [
    filterdata,
    selectedPeriod
  ]);
  const downloadData = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const excelFileName = `Parameter_Comparison_Report`;

    // Prepare data dynamically from parameterData
    const flatData = parameterData.map(param => ({
      'Parameter': param.parameter,
      'Last Month % Achv.': param.lastMonthAchv,
      'Current Month % Achv.': param.currentMonthAchv
    }));

    // Convert data to Excel sheet
    const ws = XLSX.utils.json_to_sheet(flatData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, excelFileName + fileExtension);
  };


  const handleViewGraph = (parameter) => {
    if (onViewGraph) onViewGraph(parameter);
  };

  const paramIcons = {
    Speed: speedIcon,
    'Accelerator Pedal Position': accelerationIcon,
    RPM: rpmIcon,
    Idling: idlingIcon,
    Coasting: coastingIcon,
    Regeneration: regenerationIcon
  };

  return (
    <div className="container-fluid px-4">
      <div className="row mb-4">
        <div className="col-12">
          <h3 className={`${styles.sectionTitle} mb-3 text-start`}>Parameter Comparison</h3>

          <div className="card p-3 mb-4">
            <div className="d-flex align-items-center">
              <div className="d-flex rounded-pill overflow-hidden me-4" style={{ border: '1px solid #83a4cf' }}>

              </div>
              <span className="fw-bold me-2">Last Month</span>
              <span className="text-muted">
                <em>{getDateRanges().lastMonthStartDate} - {getDateRanges().lastMonthEndDate}</em>
              </span>


              <span className="text-muted me-3">|</span>
              <span className="fw-bold me-2">Current Month</span>
              <span className="text-muted">
                <em>{getDateRanges().currentMonthStartDate} - {getDateRanges().currentMonthEndDate}</em>
              </span>
            </div>
          </div>

          <div className="row g-3">
            {parameterData.map((param, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="card p-3">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="d-flex align-items-center">
                      <img src={paramIcons[param.parameter] || speedIcon} alt={param.parameter} className={styles.paramIcon} style={{ width: '28px', height: '28px' }} />
                      <span className={`${styles.paramTitle} ms-2`}>{param.parameter}</span>
                    </div>
                    <button
                      className={styles.viewGraphBtn}
                      onClick={() => handleViewGraph(param.parameter)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                      View Graph
                    </button>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className={styles.paramSubtitle}>Last Month % Achv.</div>
                      <div className={styles.paramValue}>{param.lastMonthAchv}</div>
                    </div>
                    <div className="col-6">
                      <div className={styles.paramSubtitle}>Current Month % Achv.</div>
                      <div className={styles.paramValue}>
                        {param.currentMonthAchv}
                        {parseFloat(param.currentMonthAchv) > parseFloat(param.lastMonthAchv) ? (
                          <span style={{ color: 'green', marginLeft: '6px' }}>⬈</span>
                        ) : parseFloat(param.currentMonthAchv) < parseFloat(param.lastMonthAchv) ? (
                          <span style={{ color: 'red', marginLeft: '6px' }}>⬊</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {parameterData.length === 0 && (
              <div className="col-12">
                <p className="text-muted">No parameter data available.</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ParameterComparison;
